import { render, staticRenderFns } from "./DayaDukungTypeView.vue?vue&type=template&id=c40f0fd2&scoped=true"
import script from "./DayaDukungTypeView.vue?vue&type=script&lang=js"
export * from "./DayaDukungTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40f0fd2",
  null
  
)

export default component.exports